module.exports = __webpack_public_path__ + "clock.svg?99c8deecfe8d39b6b79ca694eb85047f";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/clock.svg
// module id = 810
// module chunks = 2